import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'kebabCase'
})
export class KebabCasePipe implements PipeTransform {
	transform(_value: any, _args?: unknown): any {
		return null;
	}
}
